import { action, createAsyncAction } from 'typesafe-actions';
import { repositories } from 'api';
import * as types from './types';

export const fetchCheckoutData = createAsyncAction(
    types.FETCH_CHECKOUT_DATA_REQUEST,
    types.FETCH_CHECKOUT_DATA_SUCCEEDED,
    types.FETCH_CHECKOUT_DATA_FAILED,
)<string, repositories.Checkout, Error>();

export const setCheckoutValues = (
    data: any, // repositories.products.CollectionTypes.ProductsItemType
) => action(types.SET_CHECKOUT_VALUES, data);
